import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Header() {
    const { isAuthenticated, user, logout } = useAuth();
    const linkClass = "text-brand-secondary font-medium hover:text-brand-primary transition-colors";
    const activeLinkClass = "text-brand-primary";

    return (
        <header className="glass sticky top-0 z-50">
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between py-4 sm:py-0 sm:h-20 gap-4 sm:gap-0">
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-brand-primary to-emerald-400 text-white flex items-center justify-center font-bold shadow-md">HC</div>
                            <span className="font-bold text-2xl text-brand-secondary tracking-tight">Health Card</span>
                        </Link>
                    </div>
                    <div className="flex items-center justify-center flex-wrap gap-4 sm:gap-6 sm:space-x-0 w-full sm:w-auto">                        {isAuthenticated ? (
                        <>
                            <NavLink
                                to="/my-dashboard"
                                className={({ isActive }) => `${linkClass} ${isActive ? activeLinkClass : ''}`}
                            >
                                Dashboard
                            </NavLink>
                            {(user?.role === 'admin' || user?.role === 'superadmin') && (
                                <NavLink
                                    to="/portal-management-7a8b9c"
                                    className={({ isActive }) => `${linkClass} ${isActive ? activeLinkClass : ''}`}
                                >
                                    Admin Panel
                                </NavLink>
                            )}
                            <button
                                onClick={logout}
                                className="bg-brand-secondary text-white px-5 py-2.5 rounded-full font-medium hover:bg-slate-700 transition shadow-lg shadow-slate-200 ml-4"
                            >
                                Logout
                            </button>
                        </>
                    ) : (
                        <>
                            <NavLink
                                to="/login"
                                className={({ isActive }) => `${linkClass} ${isActive ? activeLinkClass : ''}`}
                            >
                                Login
                            </NavLink>
                            <NavLink
                                to="/register"
                                className="bg-brand-secondary text-white px-5 py-2.5 rounded-full font-medium hover:bg-slate-700 transition shadow-lg shadow-slate-200 ml-2"
                            >
                                Register
                            </NavLink>
                        </>
                    )}
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;

